module.exports = __webpack_public_path__ + "img/168.d082ea96.jpg";